import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'hf-contact-note',
  templateUrl: './contact-note.component.html',
  styleUrls: ['./contact-note.component.scss']
})
export class ContactNoteComponent {
  @Input() contactNote?: string;
}
